module.exports = "/fonts/fa-solid-900.eot?d2c8b126d305ba3ef5604cea2d9663a8";